import { Action } from '@ngrx/store';
import { IProfileModel } from '../../models/loyalty/IProfile.model';

// @loyaltyDocs: To define if loyalty system is turned on for current user we are sending request to Magento
export const GET_CUSTOMER = '[Customer] Getting customer';
export const GET_CUSTOMER_SUCCESS = '[Customer] Getting customer Success';
export const GET_CUSTOMER_ERROR = '[Customer] Getting customer Error';

// Actions to get customer
export class GetCustomer implements Action {
  readonly type = GET_CUSTOMER;
  constructor(public payload: any) {}
}

export class GetCustomerSuccess implements Action {
  readonly type = GET_CUSTOMER_SUCCESS;
  constructor(public payload: IProfileModel) {}
}

export class GetCustomerError implements Action {
  readonly type = GET_CUSTOMER_ERROR;
  constructor(public payload: string) {}
}

export type CustomerActions = GetCustomer | GetCustomerSuccess | GetCustomerError;
